export default {
  metadata: {
    version: '1.0.0',
    id: 'mega-menu-item-1.0.0',
    name: 'JDSMegaMenuItem',
    platform: 'web'
  },
  hierarchy: {
    container: ['jds_link']
  },
  base: {
    container: {
      'flex-direction': '{m_0}',
      'justify-content': '{m_1}',
      'align-items': '{m_2}',
      'padding-top': '{m_3}',
      'padding-bottom': '{m_4}'
    },
    jds_link: {
      kind: 'submenu'
    }
  },
  variant: {},
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      jds_link: {
        title: {
          type: 'string',
          name: 'title'
        },
        href: {
          type: 'string',
          name: 'href'
        },
        newTab: {
          type: 'boolean',
          name: 'newTab',
          platform: 'web'
        },
        routerLinkProps: {
          type: 'RouterLinkProps',
          name: 'routerLinkProps',
          platform: 'angular'
        },
        onClick: {
          type: 'string',
          name: 'onClick'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'listitem'
          }
        }
      },
      jds_link: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
